import React, { useState } from "react";
import { MdKeyboardArrowLeft } from "react-icons/md";

const SwapSettingsModal = ({ isOpen, setIsOpen }) => {
  const toggleModal = () => {
    setIsOpen(!isOpen);
  };
  const [isAuto, setIsAuto] = useState(true);
  const [slippage, setSlippage] = useState("1.00");
  const [timeValue, setTimeValue] = useState(30);
  const [isDefault, setIsDefault] = useState(false);
  const [isChecked, setIsChecked] = useState(false);
  console.log("🚀 ~ SwapSettingsModal ~ isChecked:", isChecked);

  const handleToggle = () => {
    setIsChecked(!isChecked);
  };
  const toggleAuto = () => {
    setIsAuto(!isAuto);
  };

  const handleSlippageChange = (e) => {
    const value = parseFloat(e.target.value);

    // Ensure the value stays within the allowed range
    if (value >= 1 && value <= 20) {
      setSlippage(e.target.value);
    } else if (value < 1) {
      setSlippage("1.00");
    } else if (value > 20) {
      setSlippage("20.00");
    }
  };

  return (
    <div className=" h-0 w-0">
      {/* Button to open modal */}

      {/* Modal */}
      {/* {isOpen && ( */}

      <div className="relative bg-transparent md:w-[350px] w-[250px] md:-left-[400px] -left-[250px] top-10  md:top-10 inset-0 flex items-center justify-center z-50">
        {isDefault ? (
          <div className="bg-[#131313] text-white rounded-lg p-6 ">
            <div className="flex justify-center mb-6  items-center">
              <MdKeyboardArrowLeft
                onClick={() => setIsDefault(false)}
                className="cursor-pointer"
                size={26}
              />

              <h2 className="text-center w-full text-lg font-semibold ">
                Trade Options
              </h2>
            </div>

            <div className="mb-2 flex justify-between items-center gap-3">
              <div>
                <p className="font-semibold mb-1">Default</p>
                <p className="text-sm">
                  The Uniswap client selects the cheapest trade option factoring
                  price and network costs. Includes
                </p>
              </div>
              <label class="inline-flex items-center cursor-pointer">
                <input
                  type="checkbox"
                  value=""
                  checked={isChecked}
                  onChange={handleToggle}
                  className="sr-only peer"
                />
                <div className="relative w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-[#C4FE48] dark:peer-focus:ring-[#C4FE48] rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-[#C4FE48]"></div>
              </label>
            </div>

            { !isChecked &&
              <div className="flex flex-col gap-2 mt-3">
                <div className="mb-2 flex justify-between items-center gap-3">
                  <div>
                    <p className="text-sm">privateswap</p>
                  </div>
                  <label class="inline-flex items-center cursor-pointer">
                    <input type="checkbox" value="" className="sr-only peer" />
                    <div className="relative w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-[#C4FE48] dark:peer-focus:ring-[#C4FE48] rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-[#C4FE48]"></div>
                  </label>
                </div>

                <div className="mb-2 flex justify-between items-center gap-3">
                  <div>
                    <p className="text-sm">v3 pools</p>
                  </div>
                  <label class="inline-flex items-center cursor-pointer">
                    <input type="checkbox" value="" className="sr-only peer" />
                    <div className="relative w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4  rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-[#C4FE48]"></div>
                  </label>
                </div>
                <div className="mb-2 flex justify-between items-center gap-3">
                  <div>
                    <p className="text-sm">v2 pools</p>
                  </div>
                  <label class="inline-flex items-center cursor-pointer">
                    <input type="checkbox" value="" className="sr-only peer" />
                    <div className="relative w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4   rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-[#C4FE48]"></div>
                  </label>
                </div>
              </div>
            }

            {/* Close Button */}
            <button
              onClick={toggleModal}
              className="w-full mt-4  bg-black py-4 rounded-md text-center text-white font-semibold"
            >
              Close
            </button>
          </div>
        ) : (
          <div className="bg-[#131313]  text-white rounded-lg p-6 w-[350px]">
            <h2 className="text-center text-lg font-semibold mb-6">
              Swap settings
            </h2>

            {/* Max Slippage using SlippageControl */}
            <div className="mb-2 flex justify-between items-center">
              <span>Max slippage</span>
              <div className="flex items-center space-x-2 bg-gray-800 px-4 py-2 rounded-lg">
                {/* Auto Button */}
                <button
                  onClick={toggleAuto}
                  className={`px-3 py-1 rounded-full text-sm font-semibold ${
                    isAuto
                      ? "bg-[#C4FE48] text-black"
                      : "bg-slate-700 text-gray-400"
                  }`}
                >
                  Auto
                </button>

                {/* Slippage Display/Input */}
                {isAuto ? (
                  <span className="text-gray-400 text-sm">1.00%</span>
                ) : (
                  <div className="flex">
                    <input
                      type="number"
                      value={slippage}
                      onChange={handleSlippageChange}
                      min="1"
                      max="20"
                      step="0.01"
                      className="bg-transparent text-gray-200 text-sm px-2 py-1 rounded-md w-16 focus:outline-none no-arrows"
                    />
                    <p>%</p>
                  </div>
                )}
              </div>
            </div>

            {/* Transaction Deadline */}
            <div className="flex justify-between items-center mb-4">
              <span>Transaction deadline</span>
              <div className=" flex items-center   px-3 py-1 rounded-md text-sm">
                <input
                  type="number"
                  value={timeValue}
                  onChange={(e) => setTimeValue(e.target.value)}
                  min="1"
                  max="4320"
                  className="bg-transparent text-right mr-1 text-gray-200 text-sm  py-1 rounded-md w-10 focus:outline-none no-arrows"
                />
                minutes
              </div>
            </div>

            {/* Trade Options */}
            <div className="flex justify-between items-center mb-6">
              <span>Trade options</span>
              <div
                onClick={() => setIsDefault(true)}
                className="text-gray-400 text-sm cursor-pointer"
              >
                Default &gt;
              </div>
            </div>

            {/* Close Button */}
            <button
              onClick={toggleModal}
              className="w-full bg-black py-3 rounded-md text-center text-white font-semibold"
            >
              Close
            </button>
          </div>
        )}
      </div>
      {/* )} */}
    </div>
  );
};

export default SwapSettingsModal;
